import { nextTick, watch } from "vue";
import { Vue } from "vue-class-component";
import { Prop, Ref } from "vue-property-decorator";

export class AppVivitionComponent extends Vue {
    @Prop()
    vin!: string;

    @Prop()
    playerMarkup!: string;

    @Prop()
    playerThumbMarkup?: string;

    get playerMarkup_() {
        const parser = new DOMParser();

        const doc = parser.parseFromString(this.playerMarkup, "text/html");

        doc.querySelectorAll("script").forEach((script) => script.remove());

        return doc.body.innerHTML;
    }

    get playerThumbMarkup_() {
        if (!this.playerThumbMarkup) {
            return undefined;
        }

        const parser = new DOMParser();

        const doc = parser.parseFromString(this.playerThumbMarkup, "text/html");

        doc.querySelectorAll("script").forEach((script) => script.remove());

        return doc.body.querySelector("div")?.innerHTML;
    }

    mounted() {
        watch(
            () => ({
                playerMarkup: this.playerMarkup_,
                playerThumbMarkup: this.playerThumbMarkup_,
                vin: this.vin,
            }),
            () => {
                nextTick(() => {
                    try {
                        // eslint-disable-next-line
                        window["Vivition"].API.DoRefresh();
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            { immediate: true },
        );
    }
}
